exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".cropper-dialog .el-dialog__body{padding-top:0;padding-bottom:15px;height:calc(100% - 139px);overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/CropperImage/src/main.vue"],"names":[],"mappings":"AACA,iCAAiC,cAAc,oBAAoB,0BAA0B,aAAa,CACzG","file":"main.vue","sourcesContent":["\n.cropper-dialog .el-dialog__body{padding-top:0;padding-bottom:15px;height:calc(100% - 139px);overflow:auto\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c12aa73e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/question-review/components/CropperImage/src/main.vue
// module id = 1641
// module chunks = 5 6 7 18 34